import { AvatarDto } from '../../../models/dtos/avatar.dto';
import axios from '../../axios';

export default async function getAvatarsRequest(): Promise<AvatarDto[]> {
  const response = await axios.get<AvatarDto[]>(
    `${process.env.REACT_APP_BASE_URL}/avatars`
  );
  return response.data;
}
